import { createContext } from 'react';

const SearchContext = createContext({
  query: '',
  hasEmptyPeopleList: false,
  canFetchMore: false,
  isLoading: false,
  isFetchingMore: false,
  shouldFetchOnMount: false,
  peopleList: null,
  total: null,
  /* istanbul ignore next */
  onQueryChange() {},
  /* istanbul ignore next */
  onLoadMore() {},
  /* istanbul ignore next */
  onSelect() {},
  selected: {
    id: null,
    displayName: null,
    subHeading: null,
    avatar: null,
  },
  errorCode: null,
});

export default SearchContext;
